module.exports = __webpack_public_path__ + "img/施肥管理图标.ef8c7250.svg";